export default __webpack_public_path__ + "static/media/Aura-Egg__01.1e63ee46.png";